import React from 'react';
import { faPaste } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './ReopenButton.module.css';
import { CommonButton } from '_components';


export class ReopenButton extends React.Component {
    render() {
        let cls;
        cls = this.props.color === 'blue' ? styles.button_blue : styles.button;

        if (this.props.className) {
            cls += ' ' + this.props.className;
        }

        return (
            <CommonButton title={this.props.title ? this.props.title : 'Reopen Note'} onClick={this.props.onClick} size={this.props.size} className={cls} >
                <FontAwesomeIcon icon={faPaste} transform="shrink-6" color="white" />
            </CommonButton>
        );
    }
}
